export default [
  {
    value: 'RECARGA_ONLINE',
    text: 'Recarga de celular',
  },
  {
    value: 'GIFTCARD',
    text: 'Recarga de conteúdo',
  },
  {
    value: 'OUTROS',
    text: 'Outros',
  },
  {
    value: 'TRANSFERENCIA_ENTRE_CONTA',
    text: 'Transferência entre conta',
  },
  {
    value: 'BOLETO',
    text: 'Boleto',
  },
  {
    value: 'PAGAMENTO_CONTA_BOLETO',
    text: 'Pagamento conta e boleto',
  },
  {
    value: 'TRANSFERENCIA',
    text: 'Transferência',
  },
  {
    value: 'TED_TEF',
    text: 'Ted/Tef',
  },
  {
    value: 'RECARGA_TRANSPORTE',
    text: 'Recarga de transporte',
  },
  {
    value: 'CHIP',
    text: 'Chip',
  },
];
